export const environment = {
  production: false,
  intermediate_server_url: 'https://white-qa.lightmetrics.co',
  env: 'qa',
  translation_version: 'latest',
  translation_env: 'qa',
};
